import store from '../store'
import jsonp from 'jsonp'
import queryString from 'query-string'
import serialize from 'form-serialize'

export default class Form {
  constructor () {
    ({ dom: this.dom } = store)

    // Return if there is no forms
    this.forms = document.querySelectorAll('.js-ajax-form')

    if (!this.forms.length) { return }

    this.addEvents()
  }

  addEvents () {
    for (let i = 0; i < this.forms.length; i++) {
      const form = this.forms[i]
      const submitBtn = form.querySelector('[type="submit"]')

      if (!submitBtn) {
        console.error('Could not find sumbit button for form:', form)
        continue
      }

      submitBtn.addEventListener('click', (event) => {
        this.submitForm(form)
      })
    }
  }

  submitForm (form) {
    event.preventDefault()

    const parsedAction = queryString.parseUrl(form.action)
    const endpoint = (parsedAction.url + '-json').replace(/(^\w+:|^)\/\//, '//')
    const params = {
      u: parsedAction.query.u,
      id: parsedAction.query.id
      // 'b_5ed303da45c8bbdb16b926966_6be36e254a': '' // hidden field
    }
    const formData = serialize(form)

    const q = queryString.stringify(params)

    jsonp(endpoint + '?' + q + '&' + formData, { param: 'c' }, (err, data) => {
      if (err || data.result === 'error') {
        this.error()
      } else {
        this.success()
      }
    })
  }

  success () {
    this.dom.form.classList.add('has-success')
    this.dom.form.classList.remove('has-error')
  }

  error () {
    this.dom.form.classList.add('has-error')
    this.dom.form.classList.remove('has-success')
  }
}
